// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3htmM","left":"InfoRow_left__3Ay_d"};